<template>
  <!-- <v-row>
    <v-col cols="12" sm="8" offset-sm="2"> -->
  <v-card>
    <v-card-title primary-title>
      <div class="text-h4">
        Nödetiketter         
      </div>
      <v-spacer />         
    </v-card-title>   
    <v-card-text>    
      <v-row>  
        <v-col class="align-self-center" cols="4" sm="3" md="2">
          <v-select
            v-model="amount"
            :items="items"        
            label="Antal etiketter"
          />
        </v-col>     
        <v-col class="align-self-center" cols="8">         
          <v-btn :loading="isGenerating"                 
                 small
                 @click="getBundleOrder"
          > 
            Hämta etiketter
          </v-btn>            
        </v-col>              
      </v-row>         
    
      <PDFExport ref="labels" 
                 force-page-break=".page-break" 
                 :paper-size="'A4'"
                 :scale="0.7" 
                 :margin="{top:60, left:80}"
      >
        <div v-for="(bundle,idx) in bundles"  
             :key="idx"
        >
          <EmergencyLabel :customer-id="fsstNr" 
                          :bundle-id="bundle"
                          @init="init"
          />  
          <div v-if="!isLastBundle(idx)" class="page-break" />
        </div>
      </PDFExport>    
    </v-card-text>
  </v-card>
  <!-- </v-col>
  </v-row> -->
</template>

<script>
import EmergencyLabel from '@/components/web/EmergencyLabel'
import api from '@/backend/api'
import log from '@/logger'	
//import html2pdf from 'html2pdf.js'
import { PDFExport } from '@progress/kendo-vue-pdf'

export default {
  name:'EmergencyLabelView',
  components:{EmergencyLabel,PDFExport},  
  data(){
    return{      
      amount:1,
      bundles:[],
      fsstNr:'',
      progress:0,
      nrOfInit:0
    }
  },
  computed:{   
    items(){
      let arr =[]
      for(let i = 1; i <= 20; i++){
        arr.push(i)
      }
      return arr
    },
    isLastBundle(){
      return idx=> (this.bundles.length == 1)  || (idx == this.bundles.length-1)
    },
    isGenerating () {
      return this.progress !== 0 && this.progress < 100
    }
  },  
 updated: function () {
    
    this.$nextTick(function () {
      // Code that will run only after the
      // entire view has been re-rendered
      if(!this.isGenerating && this.nrOfInit === this.amount){
        console.log('Generate pdf') 
        this.nrOfInit = 0
        this.exportToPDF()
      }

    })
  },
  methods:{
    exportToPDF () {
        this.$refs.labels.save()			
			},    
    init(id){
      console.log('Init finished ' + id)
       this.nrOfInit +=1
       this.progress += (99/this.amount)
       if(this.nrOfInit === this.amount){
         this.progress = 100
       }
    },       
    getBundleOrder(){      
      this.nrOfInit = 0
      this.progress = 1
      api.orderBundle(7,this.amount)
      .then(resp=>{
        this.fsstNr = resp.data.fsstNumber.toString()
        this.bundles = []
        for(var i = resp.data.fromNumber;i <= resp.data.toNumber; i++){
          this.bundles.push(i.toString())
        }
        console.log('All bundles pushed')
    
        
       // this.$refs.html2Pdf.generatePdf()
      })
      .catch(error => {
        this.loading = false
        log.debug('Errors:', error)
      })
    }
  }
}
</script>